import React, {useEffect, useState} from 'react';
import {FormLabel, FormControl, Flex, CheckboxGroup, Checkbox, Text} from '@chakra-ui/react';
import {get} from '../../service/ApiService';
import {Client, Role} from '../../service/Urls';
import ErrorHelper from '../../service/ErrorHelper';
import {Controller} from 'react-hook-form';
import {CustomCheckbox} from './FormInputs';
import FlexCard from './FlexCard';
import {Heading} from '@chakra-ui/react';
import BoxCard from './BoxCard';
import {Box} from '@chakra-ui/react';
import {Stack} from '@chakra-ui/react';
import {ClientSelect} from '../Client/ClientSelect';
import {Spacer} from '@chakra-ui/react';
import {VStack} from '@chakra-ui/react';
import Roles from '../../constants/Roles';
import Select from 'react-select';

/*
 * Takes in id for the name in json, control which is in the react hook form useForm,
 * returns a new array to the form named roleList
 * @param {id,
 * @returns
 */
const RoleList = ({id, control, checkedRoles, errors, register, setValue, defaultClient, data}) => {
  const [toast, setToast] = useState({});
  const [roleList, setRoleList] = useState(null);
  const [clients, setClients] = useState([]);
  const [selectedClients, setSelectedClients] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isClientPersonnel, setClientPersonnel] = useState(false);
  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (data.roles) setClientPersonnel(data.roles.some(r => r.name === Roles.CLIENT_PERSONNEL));
  }, [data]);

  useEffect(() => {
    if (selectedClients != null) setIsLoading(false);
  }, [selectedClients]);
  const loadData = async id => {
    const roles = await get(Role.LIST);
    const clientList = await get(Client.LIST + '?PageSize=1000'); // at the time there are 200 clients, hoping this covers it so I don't have ot redo the api paging logic

    // The react-select requires a value and label
    if (clientList.data) {
      const updatedClientList = clientList.data.map(client => ({
        value: client.id,
        label: `${client.clId} | ${client.clCname}`,
      }));
      setClients(updatedClientList);
    }

    // This is to set the default values
    setDefaultValues();

    // Show error message if we can't get the main user data
    setToast(roles);
    setToast(clientList);
    if (!roles.errorMessage) {
      setRoleList(roles.data);
      // setClientPersonnel(data.some(r => r.name === Roles.CLIENT_PERSONNEL));
    }
  };

  const setDefaultValues = () => {
    // This is to set the default values
    let selectedList = [];
    if (data.clients && data.clients.length > 0) {
      selectedList = data.clients.map(client => ({
        value: client.id,
        label: `${client.clId} | ${client.clCname}`,
      }));
    }
    setValues(selectedList);
    setSelectedClients(selectedList);
  };

  const setValues = values => {
    // filter just the id from the values
    const newValues = values.map(v => v.value);
    setValue('clients', newValues); // this sets the rhf value so when we submit it's in the form data
  };
  const handleRoleChange = checkedList => {
    setClientPersonnel(checkedList.includes(Roles.CLIENT_PERSONNEL));
  };
  return (
    <Flex flexDir={{base: 'column', lg: 'row'}}>
      <FormControl>
        <FormLabel htmlFor="roles" mb="-0.5" ml="1" fontSize="sm">
          Role
        </FormLabel>
        {roleList && (
          <Controller
            control={control}
            name={'roleList'}
            defaultValue={checkedRoles.length > 0 ? checkedRoles : roleList[0].name}
            render={({field: {ref, onChange, ...rest}}) => (
              <CheckboxGroup
                {...rest}
                onChange={checkedList => {
                  handleRoleChange(checkedList);
                  onChange(checkedList);
                }}
              >
                {roleList.map(role => {
                  return (
                    <Checkbox key={role.id} mx="2" colorScheme={'tertiary'} value={role.name}>
                      {role.description}
                    </Checkbox>
                  );
                })}
              </CheckboxGroup>
            )}
            rules={{
              required: true,
            }}
          />
        )}
        {errors.roleList && (
          <Text color="red.400" fontSize="sm">
            At least one role is required
          </Text>
        )}

        {isClientPersonnel && (
          <BoxCard>
            <Box textAlign={'start'}>
              <Heading size="md" mb="2">
                Report Settings
              </Heading>
              <Flex>
                <Stack textAlign={'start'} ml="4">
                  <CustomCheckbox control={control} id="canSeeOppPlanReports" name="Can See Opportunity Plan Reports" />
                  <CustomCheckbox control={control} id="canSeeOppPlanSetupReport" name="Can See Opportunity Plan Setup Report" />
                  <CustomCheckbox control={control} id="canSeePivotTableReports" name="Can See Pivot Table Reports" />
                </Stack>
                <Stack textAlign={'start'} ml="4">
                  <CustomCheckbox control={control} id="canSeeRevenueReports" name="Can See Revenue Reports" />
                  <CustomCheckbox control={control} id="canSeeArrangerPerformanceReview" name="Performance Review Arranger" />
                  <CustomCheckbox control={control} id="canSeeManagerPerformanceReview" name="Performance Review Manager" />
                </Stack>
              </Flex>
            </Box>

            <Spacer />

            <Stack textAlign={'start'}>
              <Heading size="md" mt="2">
                Clients
              </Heading>
              {clients.length > 0 && !isLoading && (
                <Select options={clients} isMulti onChange={values => setValues(values)} defaultValue={selectedClients.map(sc => sc)} />
              )}
            </Stack>
          </BoxCard>
        )}
      </FormControl>
      <ErrorHelper toastResponse={toast} />
    </Flex>
  );
};

export default RoleList;
